// Keeps paid "extras" (native nested child cart lines) in sync with their parent
// product's quantity, so a configured product behaves as one unit in the cart.
// Loaded on the cart drawer + /cart page.
//
// Extras render read-only (no stepper / remove button — see cart-drawer.liquid and
// main-cart-items.liquid), so the only way a child's quantity changes is via its
// parent. We wrap Dawn's CartItems.updateQuantity: when a parent line's quantity
// changes to N (> 0), set every child line to N first (one /cart/update.js call),
// then let Dawn change the parent and re-render once. Removing a parent (quantity 0)
// cascades to its children natively, so that path is left untouched.
(function () {
  function patch() {
    if (window.__bundleCartPatched || typeof CartItems === 'undefined') return;
    window.__bundleCartPatched = true;

    // Children render immediately after their parent with the .cart-item__nested-line
    // class (Shopify orders nested lines right after their parent), so we collect them
    // by walking the following sibling rows — no reliance on parent_relationship.parent.key.
    function childKeysFor(parentRow) {
      const keys = [];
      let el = parentRow ? parentRow.nextElementSibling : null;
      while (el && el.classList && el.classList.contains('cart-item__nested-line')) {
        if (el.dataset.lineKey) keys.push(el.dataset.lineKey);
        el = el.nextElementSibling;
      }
      return keys;
    }

    const originalUpdateQuantity = CartItems.prototype.updateQuantity;
    CartItems.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      const proceed = () =>
        originalUpdateQuantity.call(this, line, quantity, event, name, variantId);

      const parentRow =
        this.querySelector(`#CartItem-${line}`) || this.querySelector(`#CartDrawer-Item-${line}`);
      const childKeys = childKeysFor(parentRow);

      // Not a bundle parent, or it's being removed (children cascade natively): default behaviour.
      if (childKeys.length === 0 || parseInt(quantity, 10) <= 0) return proceed();

      const updates = {};
      childKeys.forEach((key) => {
        updates[key] = quantity;
      });

      this.enableLoading(line);
      return fetch(routes.cart_update_url, { ...fetchConfig(), body: JSON.stringify({ updates }) })
        .then(proceed)
        .catch((e) => {
          console.error(e);
          proceed();
        });
    };
  }

  // CartItems is defined by cart.js (deferred); DOMContentLoaded guarantees it exists.
  patch();
  if (!window.__bundleCartPatched) document.addEventListener('DOMContentLoaded', patch);
})();
